import { defineComponent as h, h as d, mergeProps as p, computed as m } from "vue";
import g from "./highrise1171.mjs";
import { warn as v } from "./highrise1064.mjs";
import C from "./highrise1053.mjs";
import l from "./highrise984.mjs";
import b from "./highrise1011.mjs";
import { useThemeClass as _ } from "./highrise1062.mjs";
import { formatLength as $ } from "./highrise1090.mjs";
const y = Object.assign(Object.assign({}, l.props), {
  depth: [String, Number],
  size: [Number, String],
  color: String,
  component: [Object, Function]
}), N = h({
  _n_icon__: !0,
  name: "Icon",
  inheritAttrs: !1,
  props: y,
  setup(e) {
    const {
      mergedClsPrefixRef: o,
      inlineThemeDisabled: i
    } = C(e), r = l("Icon", "-icon", g, b, e, o), s = m(() => {
      const {
        depth: t
      } = e, {
        common: {
          cubicBezierEaseInOut: c
        },
        self: a
      } = r.value;
      if (t !== void 0) {
        const {
          color: f,
          [`opacity${t}Depth`]: u
        } = a;
        return {
          "--n-bezier": c,
          "--n-color": f,
          "--n-opacity": u
        };
      }
      return {
        "--n-bezier": c,
        "--n-color": "",
        "--n-opacity": ""
      };
    }), n = i ? _("icon", m(() => `${e.depth || "d"}`), s, e) : void 0;
    return {
      mergedClsPrefix: o,
      mergedStyle: m(() => {
        const {
          size: t,
          color: c
        } = e;
        return {
          fontSize: $(t),
          color: c
        };
      }),
      cssVars: i ? void 0 : s,
      themeClass: n == null ? void 0 : n.themeClass,
      onRender: n == null ? void 0 : n.onRender
    };
  },
  render() {
    var e;
    const {
      $parent: o,
      depth: i,
      mergedClsPrefix: r,
      component: s,
      onRender: n,
      themeClass: t
    } = this;
    return !((e = o == null ? void 0 : o.$options) === null || e === void 0) && e._n_icon__ && v("icon", "don't wrap `n-icon` inside `n-icon`"), n == null || n(), d("i", p(this.$attrs, {
      role: "img",
      class: [`${r}-icon`, t, {
        [`${r}-icon--depth`]: i,
        [`${r}-icon--color-transition`]: i !== void 0
      }],
      style: [this.cssVars, this.mergedStyle]
    }), s ? d(s) : this.$slots);
  }
});
export {
  N as NIcon,
  y as iconProps
};
